<a class="btn" [href]="url" [target]="targetSelf ? '_self' : '_blank'" [innerText]="title"></a>
